import { AddCircle } from "@mui/icons-material";
import { MenuItem, Tooltip } from "@mui/material";
import { Form } from "formik";
import * as Yup from "yup";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextField from "../../../commons/formik/formikTextField";
import { StyledNewAccident } from "../../../styled/accident";
import { StyledForm } from "../../../styled/form";

const NewAccident = ({
  handleSubmit,
  documentTypes,
  firstFieldName,
  firstFieldLabel,
  firstFieldOptions,
  initialValues,
}) => {
  const validation = Yup.object({
    [firstFieldName]: Yup.object().required("Campo obligatorio"),
    tipoDocumento: Yup.string().required("Campo obligatorio"),
    numeroDocumento: Yup.string().required("Campo obligatorio"),
  });

  return (
    <div>
      <StyledNewAccident.Title variant="h6">
        Agregar siniestro
      </StyledNewAccident.Title>
      <StyledNewAccident.StyledPaper>
        <FormikForm
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validation}
          onSubmit={handleSubmit}>
          {({ values }) => (
            <Form>
              <StyledForm.Input>
                <FormikSelect
                  name={firstFieldName}
                  value={values[firstFieldName]}
                  label={firstFieldLabel}>
                  {firstFieldOptions.map((option) => (
                    <MenuItem value={option} key={option.id}>
                      {option.nombre}
                    </MenuItem>
                  ))}
                </FormikSelect>
              </StyledForm.Input>
              <StyledForm.Input>
                <FormikSelect
                  name="tipoDocumento"
                  value={values.tipoDocumento}
                  label="Tipo Documento">
                  {documentTypes.map((documentType) => (
                    <MenuItem value={documentType.tipo} key={documentType.id}>
                      {documentType.tipo}
                    </MenuItem>
                  ))}
                </FormikSelect>
              </StyledForm.Input>
              <StyledForm.Input>
                <FormikTextField
                  id="numeroDocumento"
                  name="numeroDocumento"
                  label="Documento Trabajador"
                  type="text"
                  variant="standard"
                />
              </StyledForm.Input>
              <Tooltip title="Ingresar Siniestro">
                <StyledForm.Button
                  variant="contained"
                  type="submit"
                  color="primary">
                  <AddCircle />
                </StyledForm.Button>
              </Tooltip>
            </Form>
          )}
        </FormikForm>
      </StyledNewAccident.StyledPaper>
    </div>
  );
};

export default NewAccident;
